<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      :boundItemsUrl="boundItemsUrl"
      :columns="$options.columns"
      :hasSelectColumn="true"
      :inDetailsAsidePanel="inDetailsAsidePanel"
      :itemType="$options.itemType"
      :linkText="$options.configurationGroupLinkText"
      :route="$options.route"
      :selectionItemText="$options.configurationGroupItemText"
      :showBound="true"
      :showSearchForm="true"
    />
  </div>
</template>

<script>
import { ItemTableConsts } from 'client/util/Constants';
import GroupTypeIcon from 'client/components/ItemTable/BodyComponents/GroupTypeIcon.vue';
import ItemName from 'client/components/ItemTable/BodyComponents/ItemName.vue';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import ItemType from 'client/util/Constants/ItemType';

const { columnTypes } = ItemTableConsts;
const { ConfigurationGroupItemType } = ItemType;

const configurationGroupItem = new ConfigurationGroupItemType();

export default {
  name: 'ConfigurationGroupItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
  ],

  columns: [
    {
      bodyComponent: GroupTypeIcon,
      classNames: {
        body: [columnTypes.iconColumn],
        heading: [columnTypes.iconColumn],
      },
      headingText: 'Type',
    },
    {
      bodyComponent: ItemName,
      bodyComponentProps: {
        titleField: 'name',
        subtitleValue: 'Group of Configurations',
      },
      headingText: 'Group',
      sortBy: 'name',
    },
  ],

  configurationGroupLinkText: configurationGroupItem.titlePlural,

  configurationGroupItemText: {
    label: 'bound',
    plural: configurationGroupItem.titlePlural,
    singular: configurationGroupItem.title,
  },

  itemType: configurationGroupItem.type,

  route: configurationGroupItem.route,
};
</script>
